// TypedUseSelectorHook isn't deprecated. Need to update @types/react-redux https://github.com/reduxjs/react-redux/issues/1678
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { Store } from 'builder/modules/store'

const useAppSelector: TypedUseSelectorHook<Store> = useSelector

export { useAppSelector }
